export interface NavDataItem {
  id: string;
  idName: string;
  endpoint?: string;
  menuCountEndpoint?: string;
  dashboardGroupId?: string;
  isVrmAnalyticsDashboard?: boolean;
}

export interface NavData {
  [key: string]: NavDataItem;
}

export const navData: NavData = {
  // Status report
  statusReport: { id: 'statusReport', idName: 'Analytics' },
  dashboard: {
    id: 'dashboard',
    idName: 'Dashboard',
    dashboardGroupId: 'main',
  },
  vrmUKDashboard: {
    id: 'vrmUKDashboard',
    idName: 'VRM UK Dashboard',
    dashboardGroupId: 'vrmUKDashboard',
  },
  mentorDashboard: {
    id: 'mentorDashboard',
    idName: 'Mentor Dashboard',
    dashboardGroupId: 'mentorDashboard',
  },
  mentorTrendsDashboard: {
    id: 'mentorTrendsDashboard',
    idName: 'Mentor Trends Dashboard',
    dashboardGroupId: 'mentorTrendsDashboard',
  },
  coachingDashboard: {
    id: 'coachingDashboard',
    idName: 'Coaching Dashboard',
    dashboardGroupId: 'coachingDashboard',
  },
  licenceCheckDashboard: {
    id: 'licenceCheckDashboard',
    idName: 'Licence Check Dashboard',
    dashboardGroupId: 'licenceCheckDashboard',
  },
  vrmAnalyticsDashboard: {
    id: 'main',
    idName: 'Dashboard',
    dashboardGroupId: 'main',
    isVrmAnalyticsDashboard: true,
  },
  vrmAnalyticsVrmUKDashboard: {
    id: 'vrmUKDashboard',
    idName: 'VRM UK Dashboard',
    dashboardGroupId: 'vrmUKDashboard',
    isVrmAnalyticsDashboard: true,
  },
  vrmAnalyticsMentorDashboard: {
    id: 'mentorDashboard',
    idName: 'Mentor Dashboard',
    dashboardGroupId: 'mentorDashboard',
    isVrmAnalyticsDashboard: true,
  },
  vrmAnalyticsMentorTrendsDashboard: {
    id: 'mentorTrendsDashboard',
    idName: 'Mentor Trends Dashboard',
    dashboardGroupId: 'mentorTrendsDashboard',
    isVrmAnalyticsDashboard: true,
  },
  vrmAnalyticsCoachingDashboard: {
    id: 'coachingDashboard',
    idName: 'Coaching Dashboard',
    dashboardGroupId: 'coachingDashboard',
    isVrmAnalyticsDashboard: true,
  },
  vrmAnalyticsLicenceCheckDashboard: {
    id: 'licenceCheckDashboard',
    idName: 'Licence Check Dashboard',
    dashboardGroupId: 'licenceCheckDashboard',
    isVrmAnalyticsDashboard: true,
  },
  vrmAnalyticsMvrDashboard: {
    id: 'mainMVR',
    idName: 'MVR Dashboard',
    dashboardGroupId: 'mvrDashboard',
  },
  customReports: {
    id: 'customReports',
    idName: 'Custom Reports',
    endpoint: 'custom',
  },

  // Culture
  culture: { id: 'culture', idName: 'Culture' },
  privacy: {
    id: 'privacy',
    idName: 'Privacy',
    endpoint: 'culture/privacy',
  },
  altPrivacy: {
    id: 'altPrivacy',
    idName: 'Alt Privacy',
    endpoint: 'culture/alt_privacy',
  },
  policy: {
    id: 'policy',
    idName: 'Policy',
    endpoint: 'culture/policy',
  },
  pledge: {
    id: 'pledge',
    idName: 'Pledge',
    endpoint: 'culture/pledge',
  },
  managerPledge: {
    id: 'managerPledge',
    idName: 'Manager Pledge',
    endpoint: 'culture/manager_pledge',
  },
  mentorConsent: {
    id: 'mentorConsent',
    idName: 'Mentor Consent',
    endpoint: 'culture/mentor_consent',
  },
  authorizationToDrive: {
    id: 'authorizationToDrive',
    idName: 'Authorization To Drive',
    endpoint: 'culture/authorisation_to_drive',
  },
  travellingForWork: {
    id: 'travellingForWork',
    idName: 'Travelling For Work',
    endpoint: 'culture/travel_for_work',
  },
  tutorialVideos: {
    id: 'tutorialVideos',
    idName: 'Tutorial Videos',
    endpoint: 'culture/tutorial_videos',
  },
  healthQuestionnaire: {
    id: 'healthQuestionnaire',
    idName: 'Health Questionnaire',
    endpoint: 'culture/health_questionnaire',
  },
  riskFoundation: {
    id: 'riskFoundation',
    idName: 'Risk Foundation',
    endpoint: 'culture/risk_foundation',
  },
  alternativeRiskFoundation: {
    id: 'alternativeRiskFoundation',
    idName: 'Alt Risk Foundation',
    endpoint: 'culture/alternative_risk_foundation',
  },
  driverDetails: {
    id: 'driverDetails',
    idName: 'Driver Details',
    endpoint: 'culture/driver_details',
  },

  // RoadRISK
  roadRisk: { id: 'roadRisk', idName: 'RoadRISK' },
  profileSummary: {
    id: 'profileSummary',
    idName: 'Profile Summary',
    endpoint: 'roadrisk/profile_summary',
  },
  profileInsights: {
    id: 'profileInsights',
    idName: 'Profile Insights',
  },
  defensiveDriving: {
    id: 'defensiveDriving',
    idName: 'Defensive Driving',
    endpoint: 'roadrisk/defensive_driving',
  },
  feedback: {
    id: 'feedback',
    idName: 'Feedback',
    endpoint: 'roadrisk/feedback',
  },
  driverRiskRating: {
    id: 'driverRiskRating',
    idName: 'Driver Risk Rating',
    endpoint: 'roadrisk/driver_risk_rating',
  },
  riskExposureSummary: {
    id: 'riskExposureSummary',
    idName: 'Risk Exposure Summary',
    endpoint: 'roadrisk/risk_exposure_summary',
  },

  // RoadRISK PIV
  roadRiskPIV: { id: 'roadRiskPIV', idName: 'RoadRISK PIV' },
  profileSummaryRoadRiskPIV: {
    id: 'profileSummaryRoadRiskPIV',
    idName: 'Profile Summary',
    endpoint: 'roadrisk_piv/profile_summary',
  },
  defensiveOperating: {
    id: 'defensiveOperating',
    idName: 'Defensive Operating',
    endpoint: 'roadrisk_piv/defensive_operating',
  },
  operatorRiskRating: {
    id: 'operatorRiskRating',
    idName: 'Operator Risk Rating',
    endpoint: 'roadrisk_piv/operator_risk_rating',
  },

  // eLearning
  eLearning: { id: 'eLearning', idName: 'eLearning' },
  oneMoreSecond: {
    id: 'oneMoreSecond',
    idName: 'One More Second',
    endpoint: 'training/oms',
  },
  riskCoachReport: {
    id: 'riskCoachReport',
    idName: 'RiskCOACH',
    endpoint: 'training/riskcoach',
  },

  // RiskCOACH
  riskCoach: { id: 'riskCoach', idName: 'RiskCOACH' },
  riskCoachDriverActivityDetail: {
    id: 'riskCoachDriverActivityDetail',
    idName: 'Driver Activity Detail',
    endpoint: 'riskcoach/driver_activity_detail',
  },

  // DriverINDEX
  driverIndex: { id: 'driverIndex', idName: 'DriverINDEX' },
  scorecard: {
    id: 'scorecard',
    idName: 'Scorecard',
    endpoint: 'driverindex/scorecard',
  },
  mentorRewards: {
    id: 'mentorRewards',
    idName: 'Mentor Rewards',
    endpoint: 'driverindex/mentor_rewards',
  },
  mentorByEdriving: {
    id: 'mentorByEdriving',
    idName: 'MENTOR by eDriving',
    endpoint: 'driverindex/mentor',
  },
  incidents: {
    id: 'incidents',
    idName: 'Incidents',
    endpoint: 'incidents',
  },
  eventsTable: {
    id: 'eventsTable',
    idName: 'Events Table',
    endpoint: 'driverindex/events_table',
  },
  riskLevelChanges: {
    id: 'riskLevelChanges',
    idName: 'Risk Level Changes',
    endpoint: 'driverindex/risk_level_changes',
  },
  universe: {
    id: 'universe',
    idName: 'Universe',
    endpoint: 'driverindex/universe',
  },
  incidentsCollisions: {
    id: 'incidentsCollisions',
    idName: 'Incidents Collisions',
    endpoint: 'driverindex/incidents_collisions',
  },
  compare: {
    id: 'driverIndexCompare',
    idName: 'Compare',
    endpoint: 'driverindex/compare',
  },
  distanceTravelled: {
    id: 'distanceTravelled',
    idName: 'Distance Travelled Report',
    endpoint: 'driverindex/distance_travelled',
  },
  workHours: {
    id: 'workHours',
    idName: 'Work Hours Report',
    endpoint: 'driverindex/work_hours',
  },
  coaching: { id: 'coaching', idName: 'Coaching' },
  coachingCompletions: {
    id: 'coachingCompletions',
    idName: 'Coaching Assignments',
    endpoint: 'coaching_interventions/completions',
  },
  amazonCoachingAssignments: {
    id: 'amazonCoachingAssignments',
    idName: 'Amazon Coaching Assignments',
    endpoint: 'amazon_coaching_assignments',
    menuCountEndpoint: '/reports/amazon_coaching_assignments/count',
  },

  // Coaching Interventions
  coachingRecommendations: { id: 'coachingRecommendations', idName: 'Coaching Recommendations' },
  OneToOne: {
    id: 'OneToOne',
    idName: 'OneToOne',
    endpoint: 'coaching_interventions/OneToOne-recommendations',
    menuCountEndpoint: '/reports/coaching_interventions/OneToOne/recommendations/count',
  },
  OneToOneProCoach: {
    id: 'OneToOneProCoach',
    idName: 'OneToOne Pro Coach',
    endpoint: 'coaching_interventions/OneToOneProCoach-recommendations',
    menuCountEndpoint: '/reports/coaching_interventions/OneToOneProCoach/recommendations/count',
  },
  PccReview: {
    id: 'PccReview',
    idName: 'PCC',
    endpoint: 'coaching_interventions/PccReview-recommendations',
    menuCountEndpoint: '/reports/coaching_interventions/PccReview/recommendations/count',
  },
  PccReviewProCoach: {
    id: 'PccReviewProCoach',
    idName: 'PCC Pro Coach',
    endpoint: 'coaching_interventions/PccReviewProCoach-recommendations',
    menuCountEndpoint: '/reports/coaching_interventions/PccReviewProCoach/recommendations/count',
  },
  DriverImprovementReview: {
    id: 'DriverImprovementReview',
    idName: 'DriverINDEX COACH',
    endpoint: 'coaching_interventions/DriverImprovementReview-recommendations',
    menuCountEndpoint: '/reports/coaching_interventions/DriverImprovementReview/recommendations/count',
  },
  DriverIndexProCoach: {
    id: 'DriverIndexProCoach',
    idName: 'DriverINDEX PRO COACH',
    endpoint: 'coaching_interventions/DriverIndexProCoach-recommendations',
    menuCountEndpoint: '/reports/coaching_interventions/DriverIndexProCoach/recommendations/count',
  },
  OneWeekFICO_LT500: {
    id: 'OneWeekFICO_LT500',
    idName: '1 Week FICO® <559',
    endpoint: 'coaching_interventions/OneWeekFICO_LT500-recommendations',
    menuCountEndpoint: '/reports/coaching_interventions/OneWeekFICO_LT500/recommendations/count',
  },
  TwoWeeksFICO_LT710: {
    id: 'TwoWeeksFICO_LT710',
    idName: '2 Weeks FICO® <710',
    endpoint: 'coaching_interventions/TwoWeeksFICO_LT710-recommendations',
    menuCountEndpoint: '/reports/coaching_interventions/TwoWeeksFICO_LT710/recommendations/count',
  },

  // Licence Checking
  licenceChecking: { id: 'licenceChecking', idName: 'Licence Checking' },
  licenceCheckingResults: {
    id: 'licenceCheckingResults',
    idName: 'Results',
    endpoint: 'licence/results',
  },
  licenceAdmin: {
    id: 'licenceAdmin',
    idName: 'Administration',
    endpoint: 'licence/administration',
  },
  nonUkLicenceHolders: {
    id: 'nonUkLicenceHolders',
    idName: 'Non-UK Licence Holders',
    endpoint: 'licence/non_uk',
  },
  licenceTachograph: {
    id: 'licenceTachograph',
    idName: 'Tachograph',
    endpoint: 'licence/tachograph',
  },
  licenceCpc: {
    id: 'licenceCpc',
    idName: 'Licence CPC',
    endpoint: 'licence/cpc',
  },

  // MVR+
  mvrPlus: { id: 'mvrPlus', idName: 'MVR+' },
  main: {
    id: 'main',
    idName: 'MVR Check Results',
    endpoint: 'mvr/main',
  },
  drm: {
    id: 'drm',
    idName: 'DRM',
    endpoint: 'mvr/drm',
  },
  administration: {
    id: 'administration',
    idName: 'Administration',
    endpoint: 'mvr/administration',
  },
  mvrDashboard: {
    id: 'mvrDashboard',
    idName: 'MVR Dashboard',
    dashboardGroupId: 'mvrDashboard',
  },

  // Driver Summary Report
  driverSummaryReport: {
    id: 'driverSummaryReport',
    idName: 'Driver Summary Report',
    endpoint: 'mentor/driver_summary',
  },

  // DSP Performance
  dspPerformance: {
    id: 'dspPerformance',
    idName: 'DSP Performance',
    endpoint: 'mentor/distributor_dsp_performance',
  },

  // Driver Performance
  driverPerformance: { id: 'driverPerformance', idName: 'Driver Performance' },
  driverPerformanceReport: {
    id: 'driverPerformanceReport',
    idName: 'Report',
    endpoint: 'mentor/driver_performance',
  },
  tripSessionReport: {
    id: 'tripSessionReport',
    idName: 'Shift Report',
    endpoint: 'tripSessionReport',
  },
  shiftComplianceReport: {
    id: 'shiftComplianceReport',
    idName: 'Driver Shift Report',
    endpoint: '/shift_compliance',
  },
  damageReport: {
    id: 'damageReport',
    idName: 'Damages Report',
    endpoint: 'damageReport',
  },
  driverPerformanceComparison: {
    id: 'driverPerformanceComparison',
    idName: 'Comparison',
    endpoint: 'mentor/driver_performance_delta',
  },
  mentorUtilisationReport: {
    id: 'mentorUtilisationReport',
    idName: 'Mentor Utilisation',
    endpoint: 'mentor/utilisation',
  },

  // Station report
  stationReport: { id: 'stationReport', idName: 'Station Report' },
  stationReportReport: {
    id: 'stationReportReport',
    idName: 'Report',
    endpoint: 'mentor/dsp_performance',
  },
  stationReportComparison: {
    id: 'stationReportComparison',
    idName: 'Comparison',
    endpoint: 'mentor/dsp_performance_delta',
  },

  // DVCR
  dvcr: { id: 'dvcr', idName: 'DVCR' },

  // DVIR
  vehicleReports: { id: 'vehicleReports', idName: 'Vehicle Reports' },
  dvir: {
    id: 'dvir',
    idName: 'DVIR Report',
    endpoint: '/dvir',
    menuCountEndpoint: '/reports/dvir/count',
  },

  // Login Logout Report
  loginLogout: { id: 'loginLogout', idName: 'Mentor Login Report' },

  // Driver External Training
  driverExternalTraining: { id: 'driverExternalTraining', idName: 'External Training' },
  driverExternalTrainingReport: {
    id: 'driverExternalTrainingReport',
    idName: 'External Training Report',
    endpoint: '/external-training',
  },

  // Driver Activity Reporting
  driverActivityReporting: { id: 'driverActivityReporting', idName: 'Driver Activity Reporting' },
  driverActivitySummaryReport: {
    id: 'driverActivitySummaryReport',
    idName: 'Summary',
    endpoint: '/programme-activity-summary',
  },
  vrmCourseActivity: {
    id: 'vrmCourseActivity',
    idName: 'VRM Course Activity',
    endpoint: 'course_activity',
  },
  driverActivityCompare: {
    id: 'driverActivityCompare',
    idName: 'Driver Activity: Compare',
    endpoint: 'status_report/driver_activity_compare',
  },

  // Manager Tools
  managerTools: { id: 'managerTools', idName: 'Manager Tools' },
  misUsers: {
    id: 'misUsers',
    idName: 'MIS Users',
    endpoint: 'manager_tools/mis_users',
  },
  managerActivityReport: {
    id: 'managerActivityReport',
    idName: 'Manager Activity Report',
    endpoint: 'manager_tools/manager_activity_report',
  },
  driverList: {
    id: 'driverList',
    idName: 'Driver List',
    endpoint: 'manager_tools/driver_list',
  },
  customInformationContent: {
    id: 'customInformationContent',
    idName: 'Custom Content',
    endpoint: 'custom_content/tooltips',
  },

  // Self Provisioning
  users: { id: 'users', idName: 'Users' },

  // GUIDES / FAQ
  guidesFaq: { id: 'guidesFaq', idName: 'GUIDES / FAQ' },
  managerGuides: { id: 'managerGuides', idName: 'Manager Guides' },
  vrmGuides: { id: 'vrmGuides', idName: 'VRM Guides' },
  mentorFaqExternalLink: { id: 'mentorFaqExternalLink', idName: 'Mentor FAQs' },

  // MIS Notifications
  misNotifications: {
    id: 'misNotifications',
    idName: 'Notifications',
    endpoint: 'custom_content/notifications',
    menuCountEndpoint: '/reports/custom_content/notifications/count',
  },

  // Mentor TSP Summary
  mentorTspSummary: { id: 'mentorTspSummary', idName: 'Mentor TSP Summary', endpoint: 'mentor/tsp_summary' },

  // VRM Alerts
  vrmAlerts: { id: 'vrmAlerts', idName: 'VRM Alerts', endpoint: 'alerts' },

  // Driver Event Reporting
  der: {
    id: 'der',
    idName: 'Driver Event Reporting',
    endpoint: 'driver_event_reporting',
    menuCountEndpoint: '/reports/driver_event_reporting/count',
  },
  dspDer: {
    id: 'dspDer',
    idName: 'DER Overview Report',
    endpoint: 'driver_event_reporting/dsp',
  },

  // Contact Us
  contactUs: { id: 'contactUs', idName: 'Contact Us' },
  threeSixty: { id: 'threeSixty', idName: '360 Magazine' },
  //Driver Import
  driverImport: { id: 'driverImport', idName: 'Driver Import' },
};

export function findNavDataByIdName(idName: string): NavDataItem | null {
  return Object.values(navData).find((navItem) => navItem.idName === idName);
}
